import "./style.css";
import inView from "in-view";

export default class Hero {
  static selector = ".s-card";

  constructor(block) {
    this.block = block;
    this.index = this.block.getAttribute("data-instance-index");
    block.classList.add(`s-card-${this.index}`);
  }

  onEnterView() {
    this.block.classList.add("in-view");
  }

  onExitView() {
    const isHome = document.body.classList.contains("home");
    if (isHome) {
      this.block.classList.remove("in-view");
    }
  }

  onReady() {
    inView.threshold(0.5);
    inView(`.s-card-${this.index}`).on("enter", this.onEnterView.bind(this));
    inView(`.s-card-${this.index}`).on("exit", this.onExitView.bind(this));
  }
}
